import client from './apiClient';

/**
 * Legacy wrapper
 */
const legacyRequest = async (url, params, method = 'GET') => {
  const options = {
    method,
  };

  if (params?.responseType) {
    options.responseType = params.responseType;
  }

  if (params?.header) {
    options.headers = params.header;
  }

  if (params?.body) {
    options.body = params.body;
  }

  if (method === 'GET' && params && !params.responseType) {
    options.params = params;
  }

  return client.request(url, options);
};

const get = async (url, params) => {
  return legacyRequest(url, params, 'GET');
};

const post = async (url, params) => {
  return legacyRequest(url, params, 'POST');
};

const put = async (url, params) => {
  return legacyRequest(url, params, 'PUT');
};

const patch = async (url, params) => {
  return legacyRequest(url, params, 'PATCH');
};

const remove = async (url, params) => {
  return legacyRequest(url, params, 'DELETE');
};

const methods = {
  get,
  post,
  put,
  patch,
  remove,
};

export { client }; // New client
export default methods; // Legacy
